/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Save_And_LoginInputs */

const en_password_reset_save_and_login = /** @type {(inputs: Password_Reset_Save_And_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save and log in`)
};

const es_password_reset_save_and_login = /** @type {(inputs: Password_Reset_Save_And_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar e iniciar sesión`)
};

/**
* | output |
* | --- |
* | "Save and log in" |
*
* @param {Password_Reset_Save_And_LoginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_save_and_login = /** @type {((inputs?: Password_Reset_Save_And_LoginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Save_And_LoginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_save_and_login(inputs)
	return en_password_reset_save_and_login(inputs)
});